import AudienceCard from "../shared/AudienceCard";
import { AUDIENCES } from "../../data/audiences";
import Eyebrow from "../shared/Eyebrow";
import RevealText from "../shared/RevealText";

export default function AudienceGrid() {
  return (
    <section className="bg-ink py-20 md:py-28" data-testid="audience-section">
      <div className="container-emilio">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Eyebrow>Who We Clean For</Eyebrow>
            <RevealText
              as="h2"
              text={"Cleaning built for your\nkind of space."}
              className="mt-4 font-display font-extrabold text-white text-display max-w-xl"
            />
          </div>
          <p className="text-mutedtext max-w-md text-sm md:text-base">
            From homeowners to interior designers, our team scopes each visit to
            the property, the occupant, and the intended outcome.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {AUDIENCES.map((a) => (
            <AudienceCard audience={a} key={a.id} />
          ))}
        </div>
      </div>
    </section>
  );
}
